<template>
  <Loader v-if="loading" />
  <div v-else class="content">
    <table class="basic margin-top">
      <thead>
        <tr>
          <th>Date</th>
          <th>DK</th>
          <th>SE</th>
          <th>NL</th>
          <th>DE</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(subscriptions, date) in records">
          <td>{{ date }}</td>
          <td>{{ subscriptions[1] }}</td>
          <td>{{ subscriptions[2] }}</td>
          <td>{{ subscriptions[3] }}</td>
          <td>{{ subscriptions[4] }}</td>
          <td>{{ subscriptions[1] + subscriptions[2] + subscriptions[3] + subscriptions[4] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    type: {
      type: String,
      required: false,
      default: null
    }
  },
  data: () => ({
    loading: false,
    records: []
  }),
  methods: {
    load () {
      const url = this.type ? `/new-subscriptions/statistics?type=${encodeURIComponent(this.type)}` : '/new-subscriptions/statistics'
      Vue.api.get(
        url,
        {},
        {
          before: () => (this.loading = true),
          always: () => (this.loading = false),
          callback: data => (this.records = data)
        }
      )
    }
  },
  watch: {
    type () {
      this.load()
    }
  },
  created () {
    this.load()
  }
}
</script>
